<script setup>

import IndexLayout from "@/Layouts/IndexLayout.vue";
import 'vue3-carousel/dist/carousel.css'
import {Carousel, Navigation, Pagination, Slide} from 'vue3-carousel'
import CardCategory from "@/Components/CardCategory.vue";
import CardDescription from "@/Components/CardDescription.vue";
import {usePage} from "@inertiajs/vue3";
import {route} from "ziggy-js";
import NavLink from "@/Components/NavLink.vue";
import {computed} from "vue";
import PrizeDrawButton from "@/Components/Buttons/PrizeDrawButton.vue";
import ChatWidget from "@/Components/CommunityChat/ChatWidget.vue";
import {LOCALES} from "@/constants.js";

const robloxProductLink = route('roblox.index')

const page = usePage();
const isRu = computed(() => page.props?.lang === LOCALES.RU);
// Every banner carries baked-in text, so each one needs a per-locale file rather than
// an overlaid $t() string. The two locales share the artwork and differ only in the
// text layer - see docs/plans/en-localization-2026-07-31.md for how the EN files are
// produced from the RU ones.
const slides = computed(() => [
    // {
    //     image: '/assets/img/slides/cheap-rbx.webp',
    //     alt: 'Roblox',
    //     href: robloxProductLink,
    // },
    {
        image: isRu.value ? '/assets/img/slides/banner-brawl-stars.webp' : '/assets/img/slides/banner-brawl-stars-EN.webp',
        alt: 'Brawl Stars',
        href: route('products.show', {id: 7301602})
    },
    // The referral programme itself is RU-only (the banner promises a bonus in roubles),
    // so this slide has no English counterpart to swap in - it is dropped, not translated.
    ...isRu.value ? [
        {
            image: '/assets/img/slides/refprogram-banner-oct24.webp',
            alt: 'Реферальная программа ANYKOD',
            href: route('referral')
        }
    ] : [],
    {
        image: isRu.value ? '/assets/img/slides/banner-ps-plus.webp' : '/assets/img/slides/banner-ps-plus-EN.webp',
        alt: 'PS Plus',
        href: route('products.show', {id: 7301527})
    }
]);

</script>

<template>
    <IndexLayout :title="$t('HOME')">
        <h1 class="sr-only">{{ $t('AnyKod is a marketplace for game currency, subscriptions and digital goods. Guaranteed deals, verified sellers.') }}</h1>
        <Carousel :autoplay="5000" :items-to-show="1" :breakpoints="{768: {itemsToShow: 1.1}}" :wrap-around="true">
            <Slide v-for="slide in slides" :key="slide.alt">
                <NavLink :href="slide.href" class="carousel__item bg-center bg-cover"
                         :style="`background-image: url(${slide.image})`"></NavLink>
            </Slide>
            <template #addons>
                <navigation/>
                <pagination/>
            </template>

        </Carousel>
        <div
            class="mx-auto lg:px-2 lg:py-3 pb-2 pt-3 md:pb-6 flex flex-col gap-3 px-2 sm:max-w-[39rem] md:max-w-[47rem] lg:max-w-[60rem] xl:max-w-[76rem] 2xl:max-w-[87.5rem]">
            <div class="overflow-x-auto md:overflow-x-clip hidden-scroll pb-0.5 md:pb-0 -mx-2 sm:mx-0">
                <div class="grid gap-2 grid-cols-4 lg:grid-cols-5 px-2 sm:px-0">
                    <PrizeDrawButton class="hidden col-span-2 w-full lg:flex justify-center"/>
                    <CardDescription class="w-full" :text="$t('How to buy on AnyKod?')"
                                     :href="route('pages.show', {slug:'how-to-buy'})"
                    >
                        <template #icon>
                            <img src="/assets/icons/bag.svg" alt="" class="m-auto"/>
                        </template>
                    </CardDescription>
                    <CardDescription class="w-full" :text="$t('How to sell on AnyKod?')"
                                     :href="route('pages.show', {slug:'how-to-sell'})"
                    >
                        <template #icon>
                            <img src="/assets/icons/coin.svg" alt="" class="m-auto"/>
                        </template>
                    </CardDescription>
                    <CardDescription class="w-full hidden lg:flex" :text="$t('Rating and ads transfer')"
                                     :href="route('pages.show', {slug:'rating-transfer-ru'})">
                        <template #icon>
                            <img src="/assets/icons/star-main.svg" alt="" class="m-auto"/>
                        </template>
                    </CardDescription>
                    <CardDescription class="w-full lg:hidden" :text="$t('Rating transfer')"
                                     :href="route('pages.show', {slug:'rating-transfer-ru'})">
                        <template #icon>
                            <img src="/assets/icons/star-main.svg" alt="" class="m-auto"/>
                        </template>
                    </CardDescription>
                    <CardDescription class=" w-full lg:hidden" :text="$t('Ads transfer')"
                                     :href="route('pages.show', {slug:'adds-transfer-ru'})">
                        <template #icon>
                            <img src="/assets/icons/documents.svg" alt="" class="m-auto"/>
                        </template>
                    </CardDescription>

                </div>
            </div>
            <PrizeDrawButton class="mt-3 lg:hidden w-full "/>

            <ChatWidget/>

            <CardCategory :games="page.props.games" :is-many="false" :title="$t('Top in Games')"
                          :url="route('category', 'games')"></CardCategory>
            <CardCategory :games="page.props.subscriptions" :is-many="false" :title="$t('Top in Subscriptions')"
                          :url="route('category', 'game-subscriptions')"></CardCategory>
            <CardCategory :games="page.props.other" :is-many="true" :title="$t('Top in Other')"
                          :url="route('category', 'streaming-services')"></CardCategory>
            <CardCategory :games="page.props['game-currency']" category="game-currency" :is-many="true" :title="$t('Top in In-game currencies')"
                          :url="route('category', 'games')"></CardCategory>

        </div>
    </IndexLayout>
</template>

<style>


</style>
